import axios from 'axios';
import { env } from '../../../config';

export const getPowerBIEmbeddedInfos = (reportId: string) => {
  return axios.get(`${env.API_URL}/powerbi/${reportId}`);
};
